// extracted by mini-css-extract-plugin
module.exports = {"body":"Body_body__3OWgA"};